import React, { useContext } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Header from "components/Layout/Header";
import Footer from "components/Layout/Footer";
import { SignInButton } from "components/SignInButton";
import { SignOutButton } from "components/SignOutButton";
import { useIsAuthenticated } from "@azure/msal-react";
import SelectOrganization from "components/SelectOrganization";
import { FormDataContext } from "context/FormDataContext";

const OnlineUsers = () => {
  const { onlineUsers, userName } = useContext(FormDataContext);

  const otherOnlineUsers = onlineUsers.filter(
    (user) => user.userName != userName && user.jobType
  );
  const users = otherOnlineUsers.map((user, i) => (
    <UserInfo key={i}>
      {`${user.userName} fra ${user.organization} er logget på og arbejder på ${user.jobType}`}
    </UserInfo>
  ));
  if (otherOnlineUsers.length > 0) {
    return (
      <OnlineUsersPanel>
        <UserInfoList>{users}</UserInfoList>
      </OnlineUsersPanel>
    );
  } else {
    return null;
  }
};

const Layout = ({ children, title, jobTitle, showToolBar, taskbar }) => {
  const isAuthenticated = useIsAuthenticated();

  return (
    <>
      <PageWrapper>
        <Header title={title} jobTitle={jobTitle} showToolBar={showToolBar}>
          <HeaderTop>
            <div>
              <AppTitle>
                <Link to="/">Den gode ansættelse</Link>
              </AppTitle>
              <SubTitle>Dit digitale hjælpeværktøj</SubTitle>
            </div>
            <div>{isAuthenticated ? <SignOutButton /> : <SignInButton />}</div>
          </HeaderTop>
        </Header>
        {isAuthenticated && <OnlineUsers />}
        {taskbar && (
          <Taskbar>
            <SelectOrganization />
          </Taskbar>
        )}
        <Main>
          <form autoComplete="off">{children}</form>
        </Main>
        <Footer />
      </PageWrapper>
    </>
  );
};

const OnlineUsersPanel = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  background: rgba(90, 107, 126, 1);
  color: #ffffff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateX(-50%);
  transition: all 0.3s;
  border-radius: 8px 8px 0 0;
`;

const UserInfo = styled.li`
  list-style: none;
`;

const UserInfoList = styled.ul`
  margin: 0;
  padding: 1em 2.5em;
`;

const PageWrapper = styled.div`
  display: flex;
  height: 100vh;
  flex-direction: column;
`;

const Taskbar = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1em;
`;

const Main = styled.main`
  box-sizing: border-box;
  width: 100%;
  flex-grow: 1;
  padding: 22px;
  @media (min-width: 1280px) {
    width: 1280px;
  }
  margin: 0 auto;
`;

const AppTitle = styled.div`
  a {
    font-size: 24px;
    color: #ffffff;
    margin-bottom: 0;
    font-weight: 400;
    padding-top: 26px;
    text-decoration: none;
    display: block;
  }
`;

const SubTitle = styled.h2`
  font-size: 12px;
  color: #ffffff;
  margin-top: 0;
  font-weight: 400;
`;

const HeaderTop = styled.div`
  background: rgba(90, 107, 126, 1);
  padding: 1em 22px;
  display: flex;
  justify-content: space-between;
  @media print {
    display: none;
  }
`;

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  title: PropTypes.string,
  jobTitle: PropTypes.string,
  showToolBar: PropTypes.bool,
  taskbar: PropTypes.bool,
};

export default Layout;
